import {
    Controller,
    Flash,
    Form,
    Helper,
    Instance,
    Knot,
    Objekt,
    State,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';

import { GoogleCaptchaService } from '../services/googleCaptchaService';
import { MilitaryService } from '../services/militaryService';
import { UserService } from '../services/userService';

export class UsersRegistrationController extends Controller {
    private state: State;
    private dom: Knot;
    private helper: Helper;
    private flash: Flash;

    constructor(
        instances: Instance,
        private militaryService: MilitaryService,
        private googleCaptchaService: GoogleCaptchaService,
        private userService: UserService,
    ) {
        super();

        this.state = instances.state;
        this.dom = instances.dom;
        this.helper = instances.helper;
        this.flash = instances.flash;
    }

    enter(): void {
        this._initLayout();

        this.militaryService.draw(
            this.dom,
            ['#f1f2ea', '#f9fafe', '#fbfeff', '#c6c6c6', '#dad8d8', '#e2e2e2'],
            0.2,
        );
    }

    protected _initLayout(): void {
        this._initButtons();
        this._initRegistrationForm();
    }

    private _initButtons(): void {
        this.helper.link(
            '.btn-login',
            this.dom,
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('users.login'),
        );

        this.helper.iconButton(
            '.close',
            this.dom,
            () => {
                this.state.go('users.login');
            },
            '',
            true,
            [],
        );
    }

    private _initRegistrationForm(): void {
        const form = new Form(this.dom);
        form.eventSubmit = (formData) => {
            form.lock();
            const userData = formData.get<Objekt>('user');
            this.userService.create(userData).then(
                (response) => {
                    this.flash.addMessage(response.get('message'));
                    this.state.go('users.login');
                },
                (response) => {
                    this.flash.addMessage(response.get('message'));
                    form.unlock();
                    form.setErrors(response.get('errors'));
                },
            );
            this.googleCaptchaService.reset();
        };
    }

    exit(): void {
        super.exit();

        this.militaryService.reset();
    }
}

export const usersRegistrationController = app.controller(
    resources.usersRegistrationController,
    [
        resources.instances,
        resources.militaryService,
        resources.googleCaptchaService,
        resources.userService,
    ],
    UsersRegistrationController,
);
